import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const targetContainer = document.querySelector('.objects__container');
const targetEl = document.querySelector('.objects__main');
const strengthObj = document.querySelector('.objects');
const strengthFst = document.querySelector('.strength__01');
const strengthSec = document.querySelector('.strength__02');
const strengthTrd = document.querySelector('.strength__03');
const strengthBlocks = document.querySelectorAll('.strength__empContainer');
const strengthDetail01 = document.querySelector('.strength__detail--01');
const strengthDetail02 = document.querySelector('.strength__detail--02');
const strengthDetail03 = document.querySelector('.strength__detail--03');

function Strength() {
  const StrengthScroll = () => {
    const vwNow = window.screen.width;
    let isPc;
    let isSp;
    if (vwNow >= 599) {
      isPc = true;
      isSp = false;
    } else {
      isPc = false;
      isSp = true;
    }

    window.addEventListener('resize', function () {
      const vw = window.screen.width;
      if (!isPc && vw >= 599) {
        window.location.reload(false);
        isPc = true;
        isSp = false;
      }
      if (!isSp && vw < 599) {
        window.location.reload(false);
        isSp = true;
        isPc = false;
      }
    });

    const TL = gsap.timeline();

    // strengthBlocks.forEach((el) => {
    //   ScrollTrigger.create({
    //     trigger: el,
    //     pin: '.strength__main',
    //     start: 'top top',
    //     end: 'bottom top',
    //   });
    // });

    gsap.to(targetEl, {
      width: '100%',
      height: '100vh',
      top: '0%',
      left: '0%',
      scrollTrigger: {
        trigger: '.objects',
        start: 'top top',
        end: 'bottom-=40% top',
        scrub: 0.2,
        // markers: true,
        onLeave: () => {
          gsap.set(strengthFst, {
            autoAlpha: 1,
            duration: 0.4,
          });
          gsap.set(strengthSec, {
            autoAlpha: 1,
            duration: 0.4,
          });
          gsap.set(strengthTrd, {
            autoAlpha: 1,
            duration: 0.4,
          });
          TL.to(strengthObj, {
            autoAlpha: 0,
            duration: 0.4,
          }).set(strengthObj, {
            zIndex: 9,
          });
        },
        onEnterBack: () => {
          TL.to(strengthObj, {
            autoAlpha: 1,
          })
            .set(strengthSec, {
              autoAlpha: 0,
            })
            .set(strengthTrd, {
              autoAlpha: 0,
            })
            .to(strengthFst, {
              autoAlpha: 0,
              duration: 0.4,
            })
            .set(strengthObj, {
              zIndex: 11,
            });
        },
      },
    });

    let mm = gsap.matchMedia();

    mm.add('(max-width: 599px)', () => {
      gsap.to(targetContainer, {
        top: '0',
        y: '0%',
        scrollTrigger: {
          trigger: '.objects',
          start: 'top top',
          end: 'bottom-=40% top',
          scrub: 0.2,
        },
      });
    });

    mm.add('(min-width: 600px)', () => {
      gsap.to(targetContainer, {
        top: '0',
        y: '50%',
        scrollTrigger: {
          trigger: '.objects',
          start: 'top top',
          end: 'bottom-=40% top',
          scrub: 0.2,
        },
      });
    });

    const vw = window.screen.width;
    let targetSub01X;
    let targetSub02X;
    let targetSub03X;
    let targetSub03Y;
    let targetSub04X;
    let targetSub04Y;
    if (vw >= 599) {
      targetSub01X = ((204 + 24) / 1390) * 100; // 目標のx座標
      targetSub02X = (-(628 + 24) / 1390) * 100; // 目標のx座標
      targetSub03X = (-(349 + 303) / 1390) * 100; // 目標のx座標
      targetSub03Y = (-50 / 1390) * 100; // 目標のx座標
      targetSub04X = (-(568 + 84) / 1390) * 100; // 目標のx座標
      targetSub04Y = (-(50 + 34) / 1390) * 100; // 目標のx座標
    } else {
      targetSub01X = ((59 + 12) / 390) * 100; // 目標のx座標
      targetSub02X = (-(64 + 12) / 390) * 100; // 目標のx座標
      targetSub03X = (-(44 + 34) / 390) * 100; // 目標のx座標
      targetSub03Y = (-(17 + 13) / 390) * 100; // 目標のx座標
    }

    gsap.to('.objects__sub--01', {
      x: `${targetSub01X}vw`,
      top: '0',
      scrollTrigger: {
        trigger: '.objects',
        start: 'top top',
        end: 'bottom-=40% top',
        scrub: 0.2,
      },
    });
    gsap.to('.objects__sub--02', {
      x: `${targetSub02X}vw`,
      top: '0',
      scrollTrigger: {
        trigger: '.objects',
        start: 'top top',
        end: 'bottom-=40% top',
        scrub: 0.2,
      },
    });
    gsap.to('.objects__sub--03', {
      x: `${targetSub03X}vw`,
      y: `${targetSub03Y}vw`,
      scrollTrigger: {
        trigger: '.objects',
        start: 'top top',
        end: 'bottom-=40% top',
        scrub: 0.2,
      },
    });
    gsap.to('.objects__sub--04', {
      x: `${targetSub04X}vw`,
      y: `${targetSub04Y}vw`,
      scrollTrigger: {
        trigger: '.objects',
        start: 'top top',
        end: 'bottom-=40% top',
        scrub: 0.2,
      },
    });

    gsap.to('.strength__01', {
      scrollTrigger: {
        trigger: '.empFor-00',
        start: 'top top',
        end: 'bottom top',
        // markers: true,
        onLeave: () => {
          gsap.to(strengthFst, {
            autoAlpha: 0,
            duration: 0.4,
          });
        },
        onEnterBack: () => {
          gsap.to(strengthFst, {
            autoAlpha: 1,
            duration: 0.4,
          });
        },
      },
    });
    gsap.to('.strength__02', {
      scrollTrigger: {
        trigger: '.empFor-01',
        start: 'top top',
        end: 'bottom top',
        onLeave: () => {
          gsap.to(strengthSec, {
            autoAlpha: 0,
            duration: 0.4,
          });
        },
        onEnterBack: () => {
          gsap.to(strengthSec, {
            autoAlpha: 1,
            duration: 0.4,
          });
        },
      },
    });
    gsap.to('.strength__03', {
      scrollTrigger: {
        trigger: '.empFor-03',
        start: 'top top',
        end: 'bottom top',
        // onLeave: () => {
        //   gsap.to(strengthSec, {
        //     autoAlpha: 0,
        //     duration: 0.4,
        //   });
        // },
        onEnterBack: () => {
          gsap.to(strengthTrd, {
            autoAlpha: 1,
            duration: 0.4,
          });
        },
      },
    });
  };

  gsap.from(strengthDetail01, {
    y: '50px',
    autoAlpha: 0,
    duration: 1,
    scrollTrigger: {
      trigger: '.empFor-00',
      start: 'top+=20% top',
      end: 'center top',
      // markers: true,
    },
  });
  gsap.from(strengthDetail02, {
    y: '50px',
    autoAlpha: 0,
    duration: 1,
    scrollTrigger: {
      trigger: '.empFor-01',
      start: 'top+=20% top',
      end: 'center top',
      // markers: true,
    },
  });
  gsap.from(strengthDetail03, {
    y: '50px',
    autoAlpha: 0,
    duration: 1,
    scrollTrigger: {
      trigger: '.empFor-02',
      start: 'top+=20% top',
      end: 'center top',
      // markers: true,
    },
  });

  StrengthScroll();
}

export default Strength;
